export class CountryChart {
  countryName: any;
  shifts: any[] = [];
  total: any;
  filled: any;
}
